import React, { useCallback } from 'react';
import T from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import AppsDropdown from './AppsDropdown';
import AppImpactChart from './AppImpactChart';
import GranularityDropdown from './GranularityDropdown';
import SectionError from '../SectionError';
import Skeleton from '../../../../components/Skeleton';
import SimpleCard from '../../../../components/Card/SimpleCard';
import { aiAppImpactSelector, financeAppsSelector } from '../../selectors';
import { fetchAiAppImpact, fetchFinanceApps } from '../../actions';

const AppImpactCard = ({ isPublic = false, isPress }) => {
  const dispatch = useDispatch();

  const { data, settings, filters } = useSelector(aiAppImpactSelector);
  const financeApps = useSelector(financeAppsSelector);

  const handleGranularityChange = useCallback((value) => {
    dispatch(fetchAiAppImpact({ granularity: value }));
  }, []);

  const handleAppChange = useCallback((app) => {
    dispatch(fetchAiAppImpact({ app_uid: app.unified_ref_no, app }));
  }, []);

  const handleAppsFiltersChange = useCallback((nextFilters) => {
    dispatch(fetchFinanceApps(nextFilters));
  }, []);

  if (settings.error) return <SectionError />;

  return (
    <SimpleCard
      headerLeft={
        <>
          <h3 className="h3 header-heading">AI App Impact</h3>
          <p className="header-description">
            Measures how AI adoption influences behavior across the broader app ecosystem. Compare
            engagement from high-frequency AI users versus never-AI users for any app in the panel.
          </p>
        </>
      }
      headerRight={
        <>
          {!financeApps.settings.loaded && financeApps.settings.pending ? (
            <Skeleton width={120} height={32} />
          ) : (
            <AppsDropdown
              selected={filters.app}
              financeApps={financeApps}
              isPublic={isPublic}
              onChange={handleAppChange}
              onAppsFiltersChange={handleAppsFiltersChange}
            />
          )}
          <GranularityDropdown
            selected={filters.granularity}
            disabled={!financeApps.settings.loaded}
            onChange={handleGranularityChange}
          />
        </>
      }
      actionsLeft={<div className="highcharts-watermark" />}
    >
      <AppImpactChart settings={settings} data={data} filters={filters} isPress={isPress} />
    </SimpleCard>
  );
};

AppImpactCard.propTypes = {
  isPublic: T.bool,
  isPress: T.bool,
};

export default AppImpactCard;
